import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["loading", "content"];

  connect() {
    console.log("Drawer loading controller connected");
    this.showLoading();

    // Listen for custom drawer events
    this.element.addEventListener(
      "drawer:opened",
      this.drawerOpened.bind(this)
    );
    this.element.addEventListener(
      "drawer:closed",
      this.drawerClosed.bind(this)
    );
  }

  disconnect() {
    this.element.removeEventListener(
      "drawer:opened",
      this.drawerOpened.bind(this)
    );
    this.element.removeEventListener(
      "drawer:closed",
      this.drawerClosed.bind(this)
    );
  }

  showLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove("hidden");
      this.loadingTarget.classList.add("fade-in");

      // Add loading state to drawer
      this.element.classList.add("loading");
    }
  }

  hideLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add("hidden");
      this.loadingTarget.classList.remove("fade-in");

      // Remove loading state from drawer
      this.element.classList.remove("loading");
    }
  }

  // Called when Turbo Stream content is loaded
  contentLoaded() {
    this.hideLoading();
  }

  // Listen for Turbo Stream events
  beforeFetch() {
    this.showLoading();
  }

  beforeRender() {
    this.showLoading();
  }

  afterRender() {
    // Small delay to ensure smooth transition
    setTimeout(() => {
      this.hideLoading();
    }, 200);
  }

  // Show specific loading state based on step
  showStepLoading(step) {
    if (this.hasLoadingTarget) {
      this.loadingTarget.innerHTML = this.getStepLoadingHTML(step);
      this.showLoading();
    }
  }

  // Get appropriate loading HTML for each step
  getStepLoadingHTML(step) {
    switch (step) {
      case "select_student":
        return this.getStudentSelectionLoadingHTML();
      case "select_reason":
        return this.getReasonSelectionLoadingHTML();
      case "conditional_form":
        return this.getFormLoadingHTML();
      default:
        return this.getDefaultLoadingHTML();
    }
  }

  getStudentSelectionLoadingHTML() {
    return `
      <div class="space-y-6 animate-pulse">
        <div class="text-center py-4">
          <div class="loading-spinner mb-3"></div>
          <p class="text-gray-500 text-sm">Chargement de la liste des élèves...</p>
        </div>
        <!-- Student selection shimmer content -->
      </div>
    `;
  }

  getReasonSelectionLoadingHTML() {
    return `
      <div class="space-y-6 animate-pulse">
        <div class="text-center py-4">
          <div class="loading-spinner mb-3"></div>
          <p class="text-gray-500 text-sm">Chargement des motifs de radiation...</p>
        </div>
        <!-- Reason selection shimmer content -->
      </div>
    `;
  }

  getFormLoadingHTML() {
    return `
      <div class="space-y-6 animate-pulse">
        <div class="text-center py-4">
          <div class="loading-spinner mb-3"></div>
          <p class="text-gray-500 text-sm">Chargement du formulaire...</p>
        </div>
        <!-- Form shimmer content -->
      </div>
    `;
  }

  getDefaultLoadingHTML() {
    return `
      <div class="space-y-6 animate-pulse">
        <div class="text-center py-4">
          <div class="loading-spinner mb-3"></div>
          <p class="text-gray-500 text-sm">Chargement en cours...</p>
        </div>
        <!-- Default shimmer content -->
      </div>
    `;
  }

  // Listen for drawer open events
  drawerOpened() {
    this.showLoading();
  }

  // Listen for drawer close events
  drawerClosed() {
    this.hideLoading();
  }

  // Force show loading (for manual control)
  forceShow() {
    this.showLoading();
  }

  // Force hide loading (for manual control)
  forceHide() {
    this.hideLoading();
  }
}
